var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-modal-form',{attrs:{"id":_vm.$getConst('INTERVIEW_MODAL_ID'),"submit-btn":false,"title":"Хотите повысить уровень обслуживания?"}},[_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"btn background-white border-danger text-danger",attrs:{"href":_vm.formsInterviewLink}},[_vm._v(" Оценить ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }